<section class="parallax-bg fixed-bg lg-screen lg-section"
  style="background-image: url('assets/images/slides/home-bg-24.png')">
  <div class="hero-text-wrap lg-screen transparent-bg">
    <div class="hero-text">
      <div class="container">
        <div class="row">
          <div class="col-md-12 centerize-col">
            <div class="all-padding-50 text-center white-color content">
              <h1>Qartis</h1>
              <h2 class="font-100 raleway-font">Find The Perfect Template</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="grey-bg pb-80">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8 centerize-col text-center">
        <div class="section-title">
          <h1 class="raleway-font">Choose the template you like</h1>
        </div>
      </div>
    </div>
    <div class="row mt-50">
      <div *ngFor="let choose of chooserTemplate" class="col-md-4 col-sm-4 col-xs-12">
        <div class="product">
          <div class="product-wrap border-white-15">
            <img src="assets/images/demo-imgs/{{choose.img}}" class="img-responsive" alt="demo1" />
            <div class="product-caption">
              <div class="product-description text-center">
                <div class="product-description-wrap">
                  <div class="product-title"> <a [routerLink]="choose.url" [ngClass]="choose.btnClass"
                      target="_blank">{{choose.btnText}}</a> </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</section>

<div class="white-bg pt-100 pb-100">
  <div class="container">
    <div class="row">
      <div class="col-md-7 mt-20 mb-80">
        <img class="img-responsive" src="assets/images/responsive-screen-2.png" alt="responsive" />
      </div>
      <div class="col-md-5 mt-80 chart-style-01">
        <div class="row">
          <div class="col-md-6 mb-30 text-center">
            <circle-progress [percent]="75" [showUnits]="false" [clockwise]="false" [radius]="100"
              [outerStrokeWidth]="4" [outerStrokeColor]="'#212121'" [outerStrokeLinecap]="'butt'"
              [showInnerStroke]="false" [titleColor]="'#212121'" [subtitle]="'RESPONSIVENESS'" [subtitleFontSize]="'18'"
              [subtitleColor]="'#212121'" [animation]="true" [animationDuration]="800"></circle-progress>
          </div>
          <div class="col-md-6 mb-30 text-center">
            <circle-progress [percent]="75" [radius]="100" [showUnits]="false" [outerStrokeWidth]="4"
              [outerStrokeColor]="'#212121'" [outerStrokeLinecap]="'butt'" [showInnerStroke]="false"
              [titleColor]="'#212121'" [subtitle]="'DESIGN'" [subtitleFontSize]="'18'" [subtitleColor]="'#212121'"
              [animation]="true" [animationDuration]="800"></circle-progress>
          </div>

          <div class="col-md-6 mb-30 text-center">
            <circle-progress [percent]="75" [radius]="100" [clockwise]="false" [showUnits]="false"
              [outerStrokeWidth]="4" [outerStrokeColor]="'#212121'" [outerStrokeLinecap]="'butt'"
              [showInnerStroke]="false" [titleColor]="'#212121'" [subtitle]="'CUSTOMIZABLE'" [subtitleFontSize]="'18'"
              [subtitleColor]="'#212121'" [animation]="true" [animationDuration]="800"></circle-progress>
          </div>
          <div class="col-md-6 mb-30 text-center">
            <circle-progress [percent]="75" [radius]="100" [showUnits]="false" [outerStrokeWidth]="4"
              [outerStrokeColor]="'#212121'" [outerStrokeLinecap]="'butt'" [showInnerStroke]="false"
              [titleColor]="'#212121'" [subtitle]="'USER FRIENDLY'" [subtitleFontSize]="'18'"
              [subtitleColor]="'#212121'" [animation]="true" [animationDuration]="800"></circle-progress>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>